/** GraphQL `executeProcessor` / queue id for the merged ask-ai processor. */
export const ASK_AI_REACT_PROCESSOR_ID = 'ask-ai-react';
